import React, { useState } from "react";

export default function ScientificCalculator() {
  const [input, setInput] = useState("");
  const [result, setResult] = useState("");

  const append = (val) => {
    setInput((prev) => prev + val);
  };

  const clear = () => {
    setInput("");
    setResult("");
  };

  const backspace = () => {
    setInput((prev) => prev.slice(0, -1));
  };

  const calculate = () => {
    try {
      let expr = input
        .replace(/π/g, Math.PI)
        .replace(/e/g, Math.E)
        .replace(/√/g, "Math.sqrt")
        .replace(/sin/g, "Math.sin")
        .replace(/cos/g, "Math.cos")
        .replace(/tan/g, "Math.tan")
        .replace(/log/g, "Math.log10")
        .replace(/\^/g, "**");

      const res = Function(`return ${expr}`)();
      setResult(res);
    } catch {
      setResult("Error");
    }
  };

  const buttons = [
    "AC", "⌫", "%", "/",
    "sin(", "cos(", "tan(", "*",
    "log(", "√(", "^", "-",
    "7", "8", "9", "+",
    "4", "5", "6", "",
    "1", "2", "3", "",
    "0", ".", "π", "e",
  ];

  return (
    <div className="min-h-screen bg-black text-white flex flex-col p-3">
      {/* Display */}
      <div className="bg-gray-900 rounded-2xl p-4 mb-3">
        <div className="text-gray-400 text-sm break-all">{input || "0"}</div>
        <div className="text-2xl font-bold break-all">
          {result !== "" ? result : ""}
        </div>
      </div>

      {/* Buttons */}
      <div className="grid grid-cols-4 gap-2 flex-1">
        {buttons.map((btn, i) => (
          <button
            key={i}
            onClick={() => {
              if (btn === "AC") clear();
              else if (btn === "⌫") backspace();
              else if (btn !== "") append(btn);
            }}
            className={`p-3 rounded-xl text-lg font-medium 
              ${btn === "AC" ? "bg-red-600" : ""}
              ${btn === "=" ? "bg-green-600 col-span-4" : "bg-gray-800"}
              active:scale-95`}
          >
            {btn}
          </button>
        ))}
      </div>

      {/* Equals Button */}
      <button
        onClick={calculate}
        className="mt-3 bg-green-600 p-4 rounded-2xl text-xl font-bold active:scale-95"
      >
        =
      </button>
    </div>
  );
}